import PropTypes from 'prop-types';
import Errored from '../Errored';
import GS from '../../grafsync/grafsync';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import { UserConsumer } from '../providers/UserProvider';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { Component, default as React } from 'react';
import AssignmentIcon from '@material-ui/icons/AssignmentInd';
import InAppBar from '../InAppBar';
import CheckDeleteAccountDialog from './CheckDeleteAccountDialog';
import MyDetails from './MyDetails';
import MyPassword from './MyPassword';
import { globalStyles as styles } from '../style/gstheme';
import { MANAGED_MODE } from '../../core/utils/constants';

class UserData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      view: 0,
      areYouSure: false,
      toIri: null,
      isErrored: null
    };
  }

  checkIfSure = () => this.setState({ areYouSure: true });

  onSure = async (user, logout) => {
    this.setState({ areYouSure: false });
    try {
      await GS.deleteAccount(user.id);
      logout();
    }
    catch (e) {
      this.setState({ isErrored: { message: "Cannot delete account. Please try again or contact support." } });
    }
  };

  onNotSure = () => this.setState({ areYouSure: false });

  changeView = (index) => this.setState({ view: index });

  render() {

    const { view, areYouSure, isErrored } = this.state;
    const { classes } = this.props;

    if (isErrored) return <Errored data={isErrored} />;

    const maxWidth = [800, 800][view];

    return (
      <UserConsumer>
        {({ user, subscriptions, updateUser, logOut }) => {
          let tabItems = [
            {
              icon: AssignmentIcon,
              label: "Detail"
            }
          ];
          if (user.ssoUser !== true) tabItems.push({
            icon: VpnKeyIcon,
            label: "Security"
          });
          return <React.Fragment>
            {subscriptions.find(subItem => !subItem.expirationDate) && window.Graphologi.mode !== MANAGED_MODE &&
              <Typography data-test="no-cancellation-allowed" variant="body2" paragraph>Please note you can only delete your account once you have cancelled any paid subscriptions.</Typography>
            }
            <InAppBar tabValue={view} onChangeTab={this.changeView} tabItems={tabItems} />
            <div>
              <div style={{ maxWidth: '800px', marginRight: 30 }}>
                {!subscriptions.find(subItem => !subItem.expirationDate) && window.Graphologi.mode !== MANAGED_MODE &&
                  !user.systemAdmin && !user.superAdmin &&
                  <Tooltip title='Permanently delete your account'>
                    <span style={{ float: 'right', marginTop: -32, color: '#DD2C00' }}>
                      <Typography variant="body2">
                        <span>Delete Account</span>
                        <IconButton data-test="delete-account" size="small" onClick={this.checkIfSure} className={classes.deleteButton} style={{ marginLeft: 6 }}>
                          <DeleteIcon style={{ color: '#DD2C00' }} />
                        </IconButton>
                      </Typography>
                    </span>
                  </Tooltip>
                }
              </div>
              <div style={{ backgroundColor: 'white', padding: '6px', marginRight: '30px', maxWidth, minHeight: 'calc(100% - 150px)' }}>
                {view === 0 && <MyDetails
                  user={user}
                  ssoUser={user.ssoUser === true}
                  updateUser={updateUser} />}
                {view === 1 && <MyPassword user={user} />}
              </div>
              {areYouSure && <CheckDeleteAccountDialog onSure={() => this.onSure(user, logOut)} onNotSure={this.onNotSure} />}
            </div>
          </React.Fragment>;
        }
        }
      </UserConsumer>
    );
  }

}

UserData.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(UserData);